module.exports = __webpack_public_path__ + "media/bootstrap-icons/chevron-up-564f0b35.svg";